import {
  //  DatePicker,
  Row,
} from 'antd'
import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import 'styleLess/signature/summary.scss'
import Aging from './components/aging'
import Alldash from './components/alldash'
import Duedate from './components/duedate'
import Inprogress from './components/inprogress'
import Noncomplete from './components/non-complete.js'
import Overdue from './components/overdue'
import { getCookie } from 'helper/cookie'
import HeaderFilter from './components/header_filter'
import moment from 'moment'
import {
  getProjectAging,
  getProjectKos,
  getProjectOverview,
  getOptiontypeStatusproject,
} from 'api/Dashboard/project_kos'
import { getPermissionControl } from 'api/Admin/rolePermission'
import { CounterContext } from 'redux/Golbalvalues'
// import { getCompanyReport } from 'api/Dashboard/company_report'
import { useHistory } from 'react-router-dom'
import lang from 'lang/en'
import { Helmet } from 'react-helmet'
const SummaryLayout = styled.div``
const Containercomponents = styled.div``
const initalState = {
  data: [],
  isLoading: true,
}

const SummaryMainComponents = () => {
  const { setPathActive, adminPermission, mainRoleUser } = useContext(CounterContext)
  const [data_aging, setData_aging] = useState(initalState.data)
  const [data_duedate, setData_duedate] = useState(initalState.data)
  const [data_kos, setData_kos] = useState(initalState.data)
  const [data_overview, setData_overview] = useState(initalState.data)
  const [data_option, setData_Option] = useState([])
  const [role_exect, setRole_exect] = useState(false)
  const [dataFilter, setDataFilter] = useState()
  const [dateSearch, setDateSearch] = useState()
  // const [default_company, setDefault_company] = useState()
  // const [stateDefault_company, setStateDefault_company] = useState()
  const [dataDetailSearchProjectList, setDataDetailSearchProjectList] = useState()
  const language = getCookie('lang')
  const word = lang[language]
  const dataCookieFilter = getCookie('project_summary_filter')

  const token = getCookie('access_token_admin')
  var today = new Date()
  var start_date = new Date()
  var date_retro = moment(start_date.setMonth(start_date.getMonth() - 4)).format(
    'YYYY-MM-DD',
  )
  var datenow = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()

  var current_date = moment(datenow).format('YYYY-MM-DD')
  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })
  const roleUser = getCookie('roleUser')
  const history = useHistory()

  const getPermission = async () => {
    let checkRead = false
    await getPermissionControl({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (roleUser == 1) {
          checkRead = true
        }
        if (error) {
          return true
        }
        if (status === 200) {
          data.result?.permission?.map((item) => {
            if (item.menu_id == 6 || item.menu_id == 7) {
              checkRead = true
            }
          })
          checkRead ? _ : history.push(`/no-permission`)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      setPathActive('/dashboard')
      getPermission()
    }
  }, [token])

  function getDataoverview(data) {
    try {
      getProjectOverview({
        params: data,
        token: token,
      }).then((response) => {
        const { status, data, error } = response
        if (status === 200) {
          setData_overview(data)
        } else {
          setData_overview([])
        }
      })
    } catch (error) {
      setData_overview([])
      console.log(error)
    }
  }
  const getOptionStatusType = () => {
    try {
      getOptiontypeStatusproject({
        token: token,
      }).then((response) => {
        const { status, data, error } = response
        if (status === 200) {
          setData_Option(data)
        } else {
          setData_Option([])
        }
      })
    } catch (error) {
      setData_Option([])
      console.log(error)
    }
  }

  const getDataProjectAging = async (data) => {
    await getProjectAging({
      params: data,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setData_aging([])
          setData_duedate([])
          return true
        }
        if (status === 200) {
          setData_aging(data)
          setData_duedate(data)
        } else {
          setData_aging([])
          setData_duedate([])
          return true
        }
      })
      .catch((error) => {
        setData_aging([])
        setData_duedate([])
        console.error(error)
      })
  }
  const getDataProjectKos = async (data) => {
    await getProjectKos({
      params: data,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setData_kos([])
          return true
        }
        if (status === 200) {
          await setData_kos(data)
        } else {
          await setData_kos([])
          return true
        }
      })
      .catch((error) => {
        setData_kos([])
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      adminPermission?.map((item) => {
        if (item.menu_id == 7) {
          setRole_exect(true)
        }
      })
    }
  }, [token, adminPermission])
  // useEffect(() => {
  //   if (token) {
  //     getCompanyReport({
  //       pathURL: mainRoleUser !== '1' ? 'company/report' : 'company?level=1',
  //       token: token,
  //     })
  //       .then(async (response) => {
  //         const { status, data, error } = response
  //         if (error) {
  //           return true
  //         }
  //         if (status === 200) {
  //           if (data.length == 1) {
  //             setDefault_company(data[0].id)
  //             setStateDefault_company(true)
  //           }
  //         } else {
  //           return true
  //         }
  //       })
  //       .catch((error) => {
  //         console.error(error)
  //       })
  //   }
  // }, [token])

  useEffect(() => {
    if (token) {
      let data = {}
      if (dataCookieFilter === undefined) {
        if (dataFilter === undefined) {
          var today = new Date()
          var datenow =
            today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
          var currentDate = moment(datenow).format('YYYY-MM-DD')
          const myArray = currentDate.split('-')
          let month = parseInt(myArray[1])
          if ([1, 2, 3].includes(month)) {
            // This is a quarter one January -> March
            var st_date = String(`${myArray[0]}-1-01`)
            var ed_date = String(`${myArray[0]}-3-31`)
            data = {
              start_date: st_date,
              end_date: ed_date,
            }
          } else if ([4, 5, 6].includes(month)) {
            // This is a quarter two April -> June
            var st_date = String(`${myArray[0]}-4-01`)
            var ed_date = String(`${myArray[0]}-6-30`)
            data = {
              start_date: st_date,
              end_date: ed_date,
            }
          } else if ([7, 8, 9].includes(month)) {
            // This is a quarter three July -> September
            var st_date = String(`${myArray[0]}-7-01`)
            var ed_date = String(`${myArray[0]}-9-30`)
            data = {
              start_date: st_date,
              end_date: ed_date,
            }
          } else if ([10, 11, 12].includes(month)) {
            //This is a quarter four October -> December
            var st_date = String(`${myArray[0]}-10-01`)
            var ed_date = String(`${myArray[0]}-12-31`)
            data = {
              start_date: st_date,
              end_date: ed_date,
            }
          }
        } else if (dataFilter == 'SearchDate') {
          data = {
            start_date: dateSearch.date[0],
            end_date: dateSearch.date[1],
          }
        } else {
          data = {
            start_date: moment(dataFilter[0].value[0]).format('YYYY-MM-DD'),
            end_date: moment(dataFilter[0].value[1]).format('YYYY-MM-DD'),
            company_id: `${dataFilter[1]?.value}`,
            operation_id: `${dataFilter[2]?.value}`,
            suboperation_id: `${dataFilter[3]?.value}`,
            project_group_id: `${dataFilter[4]?.value}`,
            subproject_group_id: `${dataFilter[5]?.value}`,
            impact_type_id: `${dataFilter[6]?.value}`,
          }
        }
      } else {
        const dataCookieToJson = eval('(' + dataCookieFilter + ')')
        data = {
          start_date:
            JSON.parse(dataCookieFilter)?.date === undefined ||
              JSON.parse(dataCookieFilter)?.date === null
              ? null
              : moment(JSON.parse(dataCookieFilter)?.date[0]).format('YYYY-MM-DD'),
          end_date:
            JSON.parse(dataCookieFilter)?.date === undefined ||
              JSON.parse(dataCookieFilter)?.date === null
              ? null
              : moment(JSON.parse(dataCookieFilter)?.date[1]).format('YYYY-MM-DD'),
          company_id:
            dataCookieToJson.company === null || dataCookieToJson.company === undefined
              ? ''
              : `${JSON.parse(dataCookieFilter)?.company}`,
          operation_id:
            dataCookieToJson.operation === null ||
              dataCookieToJson.operation === undefined
              ? ''
              : `${JSON.parse(dataCookieFilter)?.operation}`,
          suboperation_id:
            dataCookieToJson.sub_opearation === null ||
              dataCookieToJson.sub_opearation === undefined
              ? ''
              : `${JSON.parse(dataCookieFilter)?.sub_opearation}`,
          project_group_id:
            dataCookieToJson.project_group === null ||
              dataCookieToJson.project_group === undefined
              ? ''
              : `${JSON.parse(dataCookieFilter)?.project_group}`,
          subproject_group_id:
            dataCookieToJson.project_cat === null ||
              dataCookieToJson.project_cat === undefined
              ? ''
              : `${JSON.parse(dataCookieFilter)?.project_cat}`,
          impact_type_id:
            dataCookieToJson.impact_type === null ||
              dataCookieToJson.impact_type === undefined
              ? ''
              : `${JSON.parse(dataCookieFilter)?.impact_type}`,
        }
      }

      const keys = Object.keys(data)
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        const value = data[key]
        if (
          value === null ||
          value === undefined ||
          value === 'undefined' ||
          value === ''
        ) {
          delete data[key]
        }
      }
      if (data.company_id === 'null' || data.company_id === '0') {
        data = {
          end_date: data.end_date,
          start_date: data.start_date,
        }
      }

      setPathActive('/dashboard')
      getDataoverview(data)
      getDataProjectAging(data)
      getDataProjectKos(data)
      setDataDetailSearchProjectList(data)
      getOptionStatusType()
    }
  }, [
    token,
    dataFilter,
    dateSearch,
    // stateDefault_company
  ])
  return (
    <SummaryLayout className='summarylayout'>
      <Helmet>
        <title>AXONS PROJECT | Summary</title>
      </Helmet>
      <Row className='container-component summary-row1'>
        <h1 className='no-breadcrumb'>{word['Project_Summary']}</h1>
        <HeaderFilter
          token={token}
          mainRoleUser={mainRoleUser}
          date_retro={date_retro}
          current_date={current_date}
          role_exect={role_exect}
          setDataFilter={setDataFilter}
          setDateSearch={setDateSearch}
        />
      </Row>
      <Row className='summary-row2'>
        <Containercomponents className='alldash-container'>
          <Alldash
            dataDetailSearchProjectList={dataDetailSearchProjectList}
            token={token}
            data={data_overview}
            option={data_option}
            word={word}
          />
        </Containercomponents>
        <Containercomponents className='non-complete-container'>
          <Noncomplete data={data_overview} token={token} word={word} />
        </Containercomponents>
      </Row>
      <Row className='summary-row3'>
        <Containercomponents className='inprogress-container'>
          <Inprogress token={token} data_kos={data_kos} word={word} />
        </Containercomponents>
        <Containercomponents className='aging-container'>
          <Aging token={token} data={data_aging} word={word} />
        </Containercomponents>
      </Row>
      <Row className='summary-row4'>
        <Containercomponents className='overdue-container'>
          <Overdue token={token} data_aging={data_aging} word={word} />
        </Containercomponents>
        <Containercomponents className='duedate-container'>
          <Duedate token={token} data={data_duedate} word={word} />
        </Containercomponents>
      </Row>
    </SummaryLayout>
  )
}
export default SummaryMainComponents
